import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Context Providers
import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';

// Global CSS
import './index.css';

// Layout
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';

// Pages
import HomePage from './pages/HomePage';
import CatalogPage from './pages/CatalogPage';
import ProductDetailPage from './pages/ProductDetailPage';
import WishlistPage from './pages/WishlistPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import HeritagePage from './pages/HeritagePage';


/* =========================================
   SCROLL TO TOP
========================================= */

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }, [pathname]);

  return null;
};


/* =========================================
   APP
========================================= */

function App() {
  return (
    <CartProvider>
      <WishlistProvider>

        <Router>

          <ScrollToTop />

          {/* Global Toast */}
          <Toaster
            position="top-center"
            toastOptions={{
              duration: 2500,

              style: {
                background: '#4A0E17',
                color: '#FDFBF7',
                borderRadius: '16px',
                padding: '12px 18px',
                fontSize: '13px',
                fontFamily: 'serif',
                fontWeight: '600',
                border: '1px solid #E8DFC8',
                boxShadow:
                  '0 10px 25px -5px rgba(74, 14, 23, 0.4)',
              },

              iconTheme: {
                primary: '#E8DFC8',
                secondary: '#4A0E17',
              },
            }}
          />

          {/* Main Application */}
          <div
            className="
              min-h-screen
              bg-[#FDFBF7]
              text-[#4A0E17]
              flex
              flex-col
              font-sans
              selection:bg-[#4A0E17]
              selection:text-[#FDFBF7]
            "
          >

            {/* Navbar */}
            <Navbar />

            {/* Main Content */}
            <main
              className="
                w-full
                max-w-7xl
                mx-auto
                px-4
                sm:px-6
                lg:px-8
                flex-grow
                pt-4
              "
            >

              <Routes>

                {/* Home */}
                <Route
                  path="/"
                  element={<HomePage />}
                />

                {/* Saree Catalog */}
                <Route
                  path="/catalog"
                  element={<CatalogPage />}
                />

                {/* Collections */}
                <Route
                  path="/collections"
                  element={<CatalogPage />}
                />

                {/* Product */}
                <Route
                  path="/product/:id"
                  element={<ProductDetailPage />}
                />

                {/* Wishlist */}
                <Route
                  path="/wishlist"
                  element={<WishlistPage />}
                />

                {/* Cart */}
                <Route
                  path="/cart"
                  element={<CartPage />}
                />

                {/* Checkout */}
                <Route
                  path="/checkout"
                  element={<CheckoutPage />}
                />

                {/* Heritage / Our Story */}
                <Route
                  path="/heritage"
                  element={<HeritagePage />}
                />

              </Routes>

            </main>

            {/* Footer */}
            <Footer />

          </div>

        </Router>

      </WishlistProvider>
    </CartProvider>
  );
}

export default App;